import clsx from 'clsx';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useUser } from '../../contexts/UserContext';
import { Button } from '../../components/Button/NewButton';

interface Props {}

export const MobileConnectedControls = ({}: Props) => {
  const { connectedUser, connect, loading, reboot, rebooting } =
    useCitrusView();
  const { email } = useUser();

  if (loading || connectedUser === email) return null;

  const renderTakeControl = () => {
    if (connectedUser && connectedUser !== email)
      return (
        <>
          <span className="animate animate-pulse bg-amber-200 text-amber-900 font-bold rounded-full p-2 m-1">
            {connectedUser.slice(0, 2).toUpperCase()}
          </span>{' '}
          <button className="mx-4 text-xs" onClick={() => connect()}>
            TAKE CONTROL
          </button>
        </>
      );
  };

  const renderConnect = () => {
    if (connectedUser === null)
      return (
        <Button onClick={connect} disabled={rebooting}>
          CONNECT
        </Button>
      );
  };

  return (
    <div
      className={clsx(
        'absolute z-[99999] !h-fit transition-all inline-flex items-center justify-center gap-2',
        {
          'w-full !h-full': connectedUser === null,
          'top-0 left-[calc(50%-70px)]':
            connectedUser !== email && connectedUser !== null,
        }
      )}
    >
      {renderTakeControl()}
      {renderConnect()}
      <Button onClick={reboot} disabled={rebooting}>
        {rebooting ? 'Rebooting...' : 'Reboot'}
      </Button>
    </div>
  );
};
